import React, { useEffect, useState } from 'react';
import { Drawer, Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import MainHeader from '@/components/mainheader';
import PersonalNavigation from '@/components/personalnavigation';
import DesktopNavigationContext from './context';
import './index.scss';

// 桌面主导航固定在顶部，个人中心保留侧栏及窄窗口抽屉导航。
const DesktopNavigation = ({ children }) => {
  const { pathname: routePath } = useLocation();
  const pathname = routePath.replace(/\/+$/, '') || '/';
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [open, setOpen] = useState(false);
  const isDesktop = viewportWidth > 480;
  const isAuthPage = /^\/(login|register|forgot-password|reset-password)$/.test(pathname);
  const isPersonal = pathname === '/personal' || pathname.startsWith('/personal/');
  const showPersonalSidebar = isDesktop && isPersonal;
  const isCollapsed = showPersonalSidebar && viewportWidth <= 1024;
  const postManageMatch = pathname.match(/^\/posts\/([^/]+)\/manage\/?$/);
  const returnLink = postManageMatch
    ? { path: `/posts/${postManageMatch[1]}`, label: '返回帖子' }
    : null;
  useEffect(() => {
    const resize = () => { setViewportWidth(window.innerWidth); setOpen(false); };
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);
  useEffect(() => { setOpen(false); }, [pathname]);

  const personalMenu = <nav className="desktop-sidebar-menu" aria-label="个人中心侧栏">
    <PersonalNavigation showParentReturn onNavigate={() => setOpen(false)} />
  </nav>;

  return <DesktopNavigationContext.Provider value={{ returnLink, showPersonalSidebar, isCollapsed, open, toggle: () => setOpen(value => !value) }}>
    <div className={`desktop-navigation${isAuthPage ? ' desktop-navigation-auth' : ''}${showPersonalSidebar ? ' desktop-navigation-personal' : ''}`}>
      {isDesktop && !isAuthPage && <MainHeader shell />}
      {showPersonalSidebar && !isCollapsed && <Layout.Sider className="desktop-navigation-sidebar" width={200} theme="light">{personalMenu}</Layout.Sider>}
      {isCollapsed && <Drawer id="desktop-navigation-drawer" placement="left" size={240} open={open}
        onClose={() => setOpen(false)} closable={false} zIndex={100} destroyOnHidden classNames={{ root: 'desktop-navigation-drawer' }}
        styles={{ root: { top: 64 }, mask: { background: 'rgba(178, 178, 178, 0.5)' }, body: { padding: 0 } }}>
        {personalMenu}
      </Drawer>}
      <div className="desktop-navigation-content">{children}</div>
    </div>
  </DesktopNavigationContext.Provider>;
};

export default DesktopNavigation;
